var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativeFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 72,
    viewBox: "0 0 76 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 45.544,
    height: 32.607,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_17",
    "data-name": "Artboard \\u2013 17",
    clipPath: "url(#clip-Artboard_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(18.563 19.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M38.652,10.2c-.251-.077-.205-.316-.256-.492a4.573,4.573,0,0,0-3.517-3.394,5.333,5.333,0,0,0-1.268-.139c-3.9,0-7.793,0-11.69.008a2.225,2.225,0,0,1-1.743-.722c-1.157-1.25-2.341-2.474-3.514-3.708A4.6,4.6,0,0,0,13.8.311,14.874,14.874,0,0,0,12.042.24c-2.268,0-4.535-.009-6.8,0A5,5,0,0,0,2.572.9a4.534,4.534,0,0,0-2.3,4.053C.252,11.671.261,18.387.261,25.1c0,.965,0,1.929,0,2.894a4.643,4.643,0,0,0,3.655,4.515,6.434,6.434,0,0,0,1.343.139h28.3a4.752,4.752,0,0,0,4.121-2,4.555,4.555,0,0,0,.714-1.564,1.444,1.444,0,0,1,.133-.429c.033-.045.12-22.7.12-18.456",
    transform: "translate(-0.149 -0.137)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M38.439,28.506A4.72,4.72,0,0,1,34.4,32.549a9.521,9.521,0,0,1-1.012.055q-14.191,0-28.382,0a4.781,4.781,0,0,1-5-4.814Q0,16.306,0,4.822A4.731,4.731,0,0,1,4.654.01c.066,0,.132,0,.2,0C7.545-.01,10.24,0,12.934.008a4.967,4.967,0,0,1,3.8,1.666c1.1,1.187,2.23,2.34,3.329,3.525a2.24,2.24,0,0,0,1.764.748q5.883-.021,11.766,0a4.767,4.767,0,0,1,4.8,3.711c.034.137-.025.3.114.411v.075a.577.577,0,0,0,0,.451V28.113c-.089.119,0,.269-.063.393",
    transform: "translate(0 0)",
    fill: "#344675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M90.966,24.443a.331.331,0,0,1,0-.451Z",
    transform: "translate(-52.462 -13.85)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M90.9,66.9a.415.415,0,0,1,.063-.391v.376l-.028.021Z",
    transform: "translate(-52.46 -38.395)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M23.179,33.675H8.858a1.851,1.851,0,0,1-1.919-1.366,2.637,2.637,0,0,1-.062-.708V8.973A1.863,1.863,0,0,1,8.936,6.9c2.644,0,5.287.008,7.931-.005a2.163,2.163,0,0,1,1.7.724c1.126,1.211,2.278,2.4,3.41,3.6a4.91,4.91,0,0,0,3.741,1.616q5.918,0,11.84,0A1.845,1.845,0,0,1,39.5,14.212a2.745,2.745,0,0,1,.062.67q0,8.363,0,16.727A1.86,1.86,0,0,1,37.5,33.677Z",
    transform: "translate(-3.968 -3.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M97.965,8.016l.794-1.006a.266.266,0,0,1,.266-.095.269.269,0,0,1,.2.2l.31,1.243a.273.273,0,0,0,.166.188l1.191.447a.267.267,0,0,1,.131.107.273.273,0,0,1-.082.377l-1.079.68a.273.273,0,0,0-.126.215l-.054,1.28a.268.268,0,0,1-.158.234.262.262,0,0,1-.278-.041l-.98-.823a.265.265,0,0,0-.24-.052l-1.231.343a.27.27,0,0,1-.316-.362l.473-1.184a.269.269,0,0,0-.025-.252l-.7-1.065a.272.272,0,0,1-.012-.282.266.266,0,0,1,.249-.134l1.274.088a.262.262,0,0,0,.227-.106",
    transform: "translate(-55.525 -3.989)",
    fill: "#344675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M87.325,4.061a1.255,1.255,0,1,1,1.121-1.376,1.255,1.255,0,0,1-1.121,1.376h0",
    transform: "translate(-49.613 -0.899)",
    fill: "#344675"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeFolderIcon);
export default __webpack_public_path__ + "static/media/creative_folder_icon.be6a2d66b1ba85c98783fff2daaee883.svg";
export { ForwardRef as ReactComponent };